const MapStyle = [
  {
    featureType: "administrative",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
      {
        lightness: 33,
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        saturation: -100, // Set saturation to -100 for greyscale
        lightness: 0, // Set lightness to 0 for greyscale
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        saturation: -100,
        lightness: 0,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels",
    stylers: [
      {
        visibility: "off",
      },
      {
        lightness: 20,
      },
    ],
  },

  {
    featureType: "road",
    elementType: "all",
    stylers: [
      {
        lightness: 30,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        saturation: -100,
        lightness: 0,
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        saturation: -100,
        lightness: 0,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        saturation: -100,
        lightness: 0,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
      {
        saturation: -90,
        lightness: 0,
      },
    ],
  },
];

let searchCounter = 0;
function initMap() {
  // Create the map.
  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 5.75,
    center: { lat: 21.5449763, lng: -98.9680817 },
    styles: MapStyle,
    disableDefaultUI: true,
    gestureHandling: "greedy",
  });
  // Load the stores GeoJSON onto the map.
  map.data.loadGeoJson(
    storeslink,
    { idPropertyName: "storeid" }
  );
  // Wait for the GeoJSON to load
 //map.data.addListener("addfeature", function () {
  // Get the initial list of stores and show them on load
  //const initialStores = getInitialStores(map.data);
  //showStoresList(map.data, initialStores);
//});
map.data.addListener("addfeature", async function () {
  if (this.loadedOnce) return;
  this.loadedOnce = true;

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const userCoords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        const originIcon = {
          url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pin-lightgreen.webp",
          scaledSize: new google.maps.Size(30, 30),
        };

        // Show user marker (optional but recommended)
        originMarker.setPosition(userCoords);
        originMarker.setVisible(false);
        originMarker.setIcon(originIcon);

        // Calculate distances
        const rankedStores = await calculateDistances(map.data, userCoords);

        // Show sorted list
        const closestStoreId = rankedStores[0]?.storeid;
showStoresList(map.data, rankedStores, closestStoreId);
        searchCounter++;

        // Get closest store
        const closestStore = rankedStores[0];
        if (!closestStore) return;

        const feature = map.data.getFeatureById(closestStore.storeid);
        const closestCoords = feature.getGeometry().get("coordinates");

        // Center on closest store (NOT user)
        map.setCenter(closestCoords);
        map.setZoom(13);

        // ✨ OPTIONAL: auto-open info window
        showStoreInformation({
          feature: feature,
        });
      },
      () => {
        // fallback
        const initialStores = getInitialStores(map.data);
        showStoresList(map.data, initialStores);
      }
    );
  } else {
    const initialStores = getInitialStores(map.data);
    showStoresList(map.data, initialStores);
  }
});

async function findNearestStore() {
  if (!navigator.geolocation) {
    alert("Geolocalización no soportada");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      const userCoords = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      };

      const originIcon = {
        url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pin-lightgreen.webp",
        scaledSize: new google.maps.Size(30, 30),
      };

      // Show user marker (optional)
      originMarker.setPosition(userCoords);
      originMarker.setVisible(true);
      originMarker.setIcon(originIcon);

      // 🔥 Calculate distances
      const rankedStores = await calculateDistances(map.data, userCoords);

      const closestStoreId = rankedStores[0]?.storeid;

      // Update list WITH badge
      showStoresList(map.data, rankedStores, closestStoreId);
      searchCounter++;

      // Center on closest store
      const closestStore = rankedStores[0];
      if (!closestStore) return;

      const feature = map.data.getFeatureById(closestStore.storeid);
      const coords = feature.getGeometry().get("coordinates");

      map.setCenter(coords);
      map.setZoom(13);

      // Open info window
      showStoreInformation({ feature });
    },
    (error) => {
      console.error(error);
      alert("No se pudo obtener tu ubicación");
    }
  );
}
document
  .getElementById("findNearestBtn")
  .addEventListener("click", findNearestStore);

map.data.addListener("mouseover", (event) => {
  map.data.revertStyle();
  map.data.overrideStyle(event.feature, {
    icon: {
      url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pinhover.webp",
      scaledSize: new google.maps.Size(35, 35),
    },
  });
});

map.data.addListener("mouseout", (event) => {
  map.data.revertStyle();
});

  
  map.data.setStyle((feature) => {
    return {
      icon: {
        url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pin.webp",
        scaledSize: new google.maps.Size(35, 35),
      },
    };
  });

  const infoWindow = new google.maps.InfoWindow();
  
  // Show the information for a store when its marker is clicked.
  map.data.addListener("click", (event) => {
    showStoreInformation(event);
  });

  function showStoreInformation(event) {
    const name = event.feature.getProperty("name");
    const description = event.feature.getProperty("description");
    const hours = event.feature.getProperty("hours");
    const walink = event.feature.getProperty("walink");
    const glink = event.feature.getProperty("mapslink");
    const imgtienda = event.feature.getProperty("imgtienda");
    const position = event.feature.getGeometry().get("coordinates");
    const tiendaNueva = event.feature.getProperty("nueva");
    const content = `
    
    <div class="carc-cont_mapmarker">
      <div class="suc-img_cont">
        <img src="${imgtienda}" class="suc-image">
      </div>
      <div style="display:flex;flex-direction:column;align-items:center;justify-content:space-between;gap:5px;padding:5px;width:110%;background-color:#fff;">
        <img style="width:95px;height:auto;" src="https://www.mueblespergo.com/cdn/shop/files/logo-color.png?v=1693258163&width=266">
        <p class="store-name">${name}</p>

        <p style="margin:0;text-align:center;">${description}</p>

        <p style="margin:0;margin: 0 0 14px;"><b>Horario:</b> ${hours}</p>
        <a href="${glink}" class="desc_link" target=”_blank”>¿Cómo llegar?</a>
        <a href="${walink}" class="desc_link" target=”_blank”>Contáctanos</a>
      </div>
    </div>
    
  `;
    infoWindow.setContent(content);
    infoWindow.setPosition(position);
    infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
    infoWindow.open(map);

    // Center the map on the clicked store's position
    map.setCenter(position);
    map.setZoom(13); // You can adjust the zoom level as needed
  }

  function useMyLocation() {
  if (!navigator.geolocation) {
    alert("Geolocalización no soportada por tu navegador");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      const coords = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude
      };

      const originIcon = {
        url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pin-lightgreen.webp",
        scaledSize: new google.maps.Size(30, 30),
      };

      // Center map
      map.setCenter(coords);
      map.setZoom(13);

      // Show user marker
      originMarker.setPosition(coords);
      originMarker.setVisible(true);
      originMarker.setIcon(originIcon);

      // Calculate distances like autocomplete
      const rankedStores = await calculateDistances(map.data, coords);
      const closestStoreId = rankedStores[0]?.storeid;
showStoresList(map.data, rankedStores, closestStoreId);
    },
    (error) => {
      console.error(error);
      alert("No se pudo obtener tu ubicación");
    }
  );
}

  // Build and add the search bar
  const input = document.getElementById("mapsearchbar");
  const options = {
    types: [],
    componentRestrictions: { country: "mx" },
  };
  const autocomplete = new google.maps.places.Autocomplete(input, options);
  autocomplete.setFields(["address_components", "geometry", "name"]);

  // Set the origin point when the user selects an address
  const originMarker = new google.maps.Marker({ map: map });
  originMarker.setVisible(false);
  let originLocation = map.getCenter();


  
autocomplete.addListener("place_changed", async () => {
    originMarker.setVisible(false);
    originLocation = map.getCenter();
    const place = autocomplete.getPlace();

    searchCounter++;

   // if (!place.geometry) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
   //   window.alert(" '" + place.name + "' No fue encontrado");
   //   return;
   // }

    // Recenter the map to the selected address
    originLocation = place.geometry.location;
    map.setCenter(originLocation);
    map.setZoom(13);

    const originIcon = {
      url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pin-lightgreen.webp",
      scaledSize: new google.maps.Size(30, 30),
    };

    originMarker.setPosition(originLocation);
    originMarker.setVisible(true);
    originMarker.setIcon(originIcon);

    // Use the selected address as the origin to calculate distances
    // to each of the store locations
    const rankedStores = await calculateDistances(map.data, originLocation);
    showStoresList(map.data, rankedStores);

    return;
  });

  async function calculateDistances(data, origin) {
    const stores = [];
    const destinations = [];

    // Build parallel arrays for the store IDs and destinations
    data.forEach((store) => {
      const storeNum = store.getProperty("storeid");
      const storeLoc = store.getGeometry().get();

      stores.push(storeNum);
      destinations.push(storeLoc);
    });

    // Retrieve the distances of each store from the origin
    // The returned list will be in the same order as the destinations list
    const service = new google.maps.DistanceMatrixService();
    const getDistanceMatrix = (service, parameters) =>
      new Promise((resolve, reject) => {
        service.getDistanceMatrix(parameters, (response, status) => {
          if (status != google.maps.DistanceMatrixStatus.OK) {
            reject(response);
          } else {
            const distances = [];
            const results = response.rows[0].elements;
            for (let j = 0; j < results.length; j++) {
              const element = results[j];
              const distanceText = element.distance.text;
              const distanceVal = element.distance.value;
              const distanceObject = {
                storeid: stores[j],
                distanceText: distanceText,
                distanceVal: distanceVal,
              };
              distances.push(distanceObject);
            }

            resolve(distances);
          }
        });
      });

    const distancesList = await getDistanceMatrix(service, {
      origins: [origin],
      destinations: destinations,
      travelMode: "DRIVING",
      unitSystem: google.maps.UnitSystem.METRIC,
    });

    distancesList.sort((first, second) => {
      return first.distanceVal - second.distanceVal;
    });

    return distancesList;
  }
  
  function getInitialStores(data) {
    const stores = [];
    data.forEach((store) => {
      const storeNum = store.getProperty("storeid");
      const storeLoc = store.getGeometry().get();
      stores.push({
        storeid: storeNum,
        distanceVal: 0, // Set initial distance value to 0 for on-load display
      });
    });
    return stores;
  }

  function showStoresList(data, stores, closestStoreId = null) {
    // Get the store list container
    let panel = document.getElementById("storelistcont");

    // Sort stores by distance
     stores.sort((first, second) => {
        return first.distanceVal - second.distanceVal;
      });
    
      // Clear existing content in the panel
      panel.innerHTML = '';
    //
    const filteredStores = stores.filter(
      (store) => store.distanceVal <= 100000
    ); // in meters

    if (filteredStores.length === 0) {
      // Handle the case where there are no filtered stores
      panel.innerHTML += `
          <div class="store-info_cont">
            <div class="description_cont">
              <p class="place">Tienda Online</p>
              <a href="https://mueblespergo.com" style="color:#595959;">mueblespergo.com</a>
            </div>
            <div class="links-cont-search"><a href="https://api.whatsapp.com/send?phone=5564210110" target=”_blank”><img src="https://cdn.shopify.com/s/files/1/1920/5567/files/phone.webp" height="30"></a>
        </div>
        </div>
          </div>
        `;
    } else {
      // Display the results title only if searchCounter is greater than 0
if (searchCounter > 0) {
  const resultsTitle = document.createElement("div");
  resultsTitle.className = `results-title-cont`;
  resultsTitle.innerHTML = `<span style="color:#000;">Resultados</span>`;
  panel.appendChild(resultsTitle);
}
      // Append each store to the panel
      filteredStores.forEach((store) => {
        const isClosest = store.storeid == closestStoreId;

const closestBadge = isClosest
  ? `<div class="closest-badge">Más cercana</div>`
  : "";
        const currentStore = data.getFeatureById(store.storeid);
        const name = currentStore.getProperty("name");
        const description = currentStore.getProperty("description");
        const phone = currentStore.getProperty("phone");
        const walink = currentStore.getProperty("walink");
        const mapslink = currentStore.getProperty("mapslink");
        const tiendaNueva = currentStore.getProperty("nueva");
        
        

        // Append store details to panel
        const storeElement = document.createElement("div");
        storeElement.className = "store-info_cont";
        if (tiendaNueva) {
  storeElement.innerHTML = `
    ${closestBadge}
    <div class="tienda-new-badge" style="top:5px;right:5px;">Tienda Nueva</div>
    <a href="#map" class="card-link-map">
      <div class="description_cont" data-storeid="${store.storeid}">
        <p class="place" style="max-width:85%">${name}</p>
        <p class="place-address">${description}</p>
      </div>
    </a>
    <div class="links-cont-search">
      <a href="${walink}" class="store-list-link" target="_blank">
        <img src="https://cdn.shopify.com/s/files/1/1920/5567/files/phone.webp" height="30">
      </a>
      <a href="${mapslink}" class="store-list-link" target="_blank">
        <img src="https://cdn.shopify.com/s/files/1/1920/5567/files/pinclear.webp" height="30">
      </a>
    </div>
  `;
}
        else {
  storeElement.innerHTML = `
    ${closestBadge}
    <a href="#map" class="card-link-map">
      <div class="description_cont" data-storeid="${store.storeid}">
        <p class="place">${name}</p>
        <p class="place-address">${description}</p>
      </div>
    </a>
    <div class="links-cont-search">
      <a href="${walink}" class="store-list-link" target="_blank">
        <img src="https://cdn.shopify.com/s/files/1/1920/5567/files/phone.webp" height="30">
      </a>
      <a href="${mapslink}" class="store-list-link" target="_blank">
        <img src="https://cdn.shopify.com/s/files/1/1920/5567/files/pinclear.webp" height="30">
      </a>
    </div>
  `;
}

        // Append the store element to the panel
        panel.appendChild(storeElement);
      });

      // Add click event listener to all store elements in the panel
      panel.addEventListener("click", (event) => {
        const clickedStoreId =
          event.target.closest(".description_cont")?.dataset.storeid;

        if (clickedStoreId) {
          const clickedStore = data.getFeatureById(clickedStoreId);
          const clickEvent = {
            feature: clickedStore,
          };
          showStoreInformation(clickEvent);

          // Center the map on the clicked store's position
          map.setCenter(clickedStore.getGeometry().get("coordinates"));
          map.setZoom(13); // You can adjust the zoom level as needed
        }
      });
    }
  }
  
  const resetButton = document.getElementById("resetmap");
    resetButton.addEventListener("click", () => {
      // Set the map center and zoom to their initial values
      map.setCenter({ lat: 21.5449763, lng: -98.9680817 });
      map.setZoom(5.75);
  
      // Clear the input field and hide the originMarker
      input.value = "";
      originMarker.setVisible(false);
      infoWindow.setContent();
      
  
      // Reload the initial stores and show them on the map
      const initialStores = getInitialStores(map.data);
      showStoresList(map.data, initialStores);
      const resultsTitle = document.querySelector(".results-title-cont");
      const panel = document.getElementById("storelistcont");
  if (resultsTitle) {
    panel.removeChild(resultsTitle);
  }
    });

}
